import { signal } from '@preact/signals';
import { api } from '../api/client';

interface CategoryWithCount {
  id: string;
  name: string;
  slug: string;
  icon: string;
  agent_count: number;
}

export const categories = signal<CategoryWithCount[]>([]);
export const categoriesLoaded = signal(false);

export async function fetchCategories() {
  try {
    const data = await api.get<{ categories: CategoryWithCount[] }>('/categories');
    categories.value = (data.categories ?? []).filter(
      (c: CategoryWithCount) => c.agent_count > 0
    );
  } catch {
    // silent
  } finally {
    categoriesLoaded.value = true;
  }
}
